import { render, staticRenderFns } from "./RTCRReport.vue?vue&type=template&id=50167578&scoped=true&"
import script from "./RTCRReport.vue?vue&type=script&lang=js&"
export * from "./RTCRReport.vue?vue&type=script&lang=js&"
import style0 from "./RTCRReport.vue?vue&type=style&index=0&id=50167578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50167578",
  null
  
)

export default component.exports